<template>
    <div class="account-container">
      <div class="results">
        <div class="shadow-divide"></div>
        <div class="results-wrap">
          <Loader :loadType="1" v-show="isShowLoader" class="black" style="top:-12px;"></Loader>
          <div v-if="$i18n.locale === 'zh-CN'">
            <Layout>
              <Header class="scroll-border-dom">
                <BasicInfoZH :userInfo="dataSet" />
              </Header>
              <Layout>
                <Sider hide-trigger width="300">
                  <UserInfoZH :userInfo="dataSet" />
                </Sider>
                <Content>
                  <ContentZH :userInfo="dataSet" />
                </Content>
              </Layout>
            </Layout>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import BasicInfoZH from './zh-CN/BasicInfo'
import UserInfoZH from './zh-CN/UserInfo'
import ContentZH from './zh-CN/Content'

export default {
  name: 'MyAccount',
  components: { Loader, BasicInfoZH, UserInfoZH, ContentZH },
  data () {
    return {
      isShowLoader: false,
      dataSet: {}
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.requestData()
      let resultDom = document.querySelector('.results')
      let footer = document.querySelector('footer')
      resultDom.style.minHeight = (this._h.getWinHeight() - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(resultDom).top) - this._h.getRealElSize(footer).height - 48)) + 'px'
    })
  },
  methods: {
    requestData () {
      if (this.isShowLoader) return
      this.$Loading.start()
      this._h.scrollTop()
      this.isShowLoader = true
      this.$api.account.member.home({
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.dataSet = response.data.data || {}
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    }
  }
}
</script>
<style scoped>
  .results{
    position: relative;
    padding: 15px 0 5px;
  }
  .results-wrap{
    width: 75%;
    margin: 0 auto;
    padding-bottom: 50px;
    max-width: var(--contentPageMaxWidth);
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .ivu-layout{
    background-color: transparent;
  }
  .ivu-layout-header{
    background-color: transparent;
    padding: 0;
    height: auto;
    line-height: normal;
  }
  .ivu-layout-sider{
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/MyAccount.vue